(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-products"]) return;
  try {
    
if(!customElements.get('mko-drop-refresh')) {
  customElements.define('mko-drop-refresh',class extends HTMLElement {
    connectedCallback() {
      const launch=Date.parse(this.dataset.launch);
      if(!Number.isFinite(launch)||Date.now()>=launch) return;
      const check=()=>{if(Date.now()>=launch+2500&&!document.hidden){clearInterval(this.interval);location.reload();}};
      this.interval=setInterval(check,1000);
    }
    disconnectedCallback(){clearInterval(this.interval);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mko-drop-featured"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mko-drop-refresh')) {
  customElements.define('mko-drop-refresh',class extends HTMLElement {
    connectedCallback() {
      const launch=Date.parse(this.dataset.launch);
      if(!Number.isFinite(launch)||Date.now()>=launch) return;
      const check=()=>{if(Date.now()>=launch+2500&&!document.hidden){clearInterval(this.interval);location.reload();}};
      this.interval=setInterval(check,1000);
    }
    disconnectedCallback(){clearInterval(this.interval);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mko-next-drop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mko-next-drop')) {
  class MkoNextDrop extends HTMLElement {
    static parts(timestamp) {
      return Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Rome', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'}).formatToParts(new Date(timestamp)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    }
    static schedule(now, origin = '2026-09-22') {
      const p = this.parts(now);
      const day = Date.UTC(p.year, p.month - 1, p.day);
      let targetDay = day + ((2 - new Date(day).getUTCDay() + 7) % 7) * 86400000;
      if (targetDay === day && p.hour >= 22) targetDay += 7 * 86400000;
      const wallTime = targetDay + 22 * 3600000;
      let target = wallTime;
      for (let i = 0; i < 3; i++) {
        const z = this.parts(target);
        target += wallTime - Date.UTC(z.year, z.month - 1, z.day, z.hour, z.minute, z.second);
      }
      const number = 1 + Math.round((targetDay - Date.parse(origin + 'T00:00:00Z')) / 604800000);
      return {target, number};
    }
    connectedCallback() {
      this.clock = this.querySelector('[role="timer"]');
      this.onVisibility = () => this.update();
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    update() {
      const now = Date.now();
      const schedule = this.constructor.schedule(now, this.dataset.origin);
      if (this.target !== schedule.target) {
        this.target = schedule.target;
        this.querySelector('[data-drop-name]').textContent = 'Drop ' + schedule.number;
        this.querySelector('[data-date]').textContent = new Intl.DateTimeFormat(this.dataset.locale || 'it', {timeZone:'Europe/Rome', weekday:'long', day:'numeric', month:'long', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}).format(new Date(this.target));
      }
      const total = Math.max(0, Math.ceil((this.target - now) / 1000));
      const values = {days:Math.floor(total / 86400), hours:Math.floor(total / 3600) % 24, minutes:Math.floor(total / 60) % 60, seconds:total % 60};
      for (const [key, value] of Object.entries(values)) this.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0');
      this.clock.hidden = false;
    }
  }
  customElements.define('mko-next-drop', MkoNextDrop);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mko-weekly-drop"] && !Shopify.designMode) return;
  try {
    
  const mkoRomeFormatter = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  function mkoRomeParts(date) {
    return Object.fromEntries(mkoRomeFormatter.formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
  }
  function mkoRomeInstant(year,month,day,hour=22) {
    const wall=Date.UTC(year,month-1,day,hour);
    let result=wall;
    for(let i=0;i<3;i++) {
      const p=mkoRomeParts(new Date(result));
      result+=wall-Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
    }
    return result;
  }
  function mkoDropSchedule(now) {
    const p=mkoRomeParts(new Date(now));
    const day=new Date(Date.UTC(p.year,p.month-1,p.day));
    const weekday=day.getUTCDay();
    const live=weekday===2&&p.hour>=22;
    day.setUTCDate(day.getUTCDate()+(2-weekday+7)%7);
    const year=day.getUTCFullYear(),month=day.getUTCMonth()+1,date=day.getUTCDate();
    return {live,target:mkoRomeInstant(year,month,date),key:[year,String(month).padStart(2,'0'),String(date).padStart(2,'0')].join('-'),edition:Math.floor(day.getTime()/604800000)%4};
  }
  class MkoWeeklyDrop extends HTMLElement {
    connectedCallback() {
      if(this.timer) return;
      this.config=JSON.parse(this.querySelector('[data-drop-config]').textContent);
      this.locale=this.config.locale||'it';
      this.heading=this.querySelector('.mko-weekly__title');
      this.clock=this.querySelector('[data-clock]');
      this.liveLabel=this.querySelector('[data-live]');
      this.status=this.querySelector('[data-status]');
      this.calendar=this.querySelector('[data-calendar]');
      this.calendar.hidden=false;
      this.onCalendar=()=>this.saveCalendar();
      this.onVisibility=()=>{if(!document.hidden)this.tick();};
      this.calendar.addEventListener('click',this.onCalendar);
      document.addEventListener('visibilitychange',this.onVisibility);
      this.tick();
      this.timer=setInterval(()=>{if(!document.hidden)this.tick();},1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer); this.timer=null;
      this.calendar?.removeEventListener('click',this.onCalendar);
      document.removeEventListener('visibilitychange',this.onVisibility);
    }
    getSchedule(now) {
      const target=Date.parse(this.config.launchAt);
      if(Number.isFinite(target)) return {live:now>=target,target,key:this.config.launchAt.slice(0,10),edition:0};
      return mkoDropSchedule(now);
    }
    tick() {
      const now=Date.now(),schedule=this.getSchedule(now),s=this.config.strings;
      this.schedule=schedule;
      const seconds=Math.max(0,Math.ceil((schedule.target-now)/1000));
      const phase=schedule.live?'live':seconds<=3600?'soon':seconds<=86400?'today':'waiting';
      const signature=schedule.key+phase;
      if(this.signature!==signature) {
        this.signature=signature;
        const edition=this.config.editions.find(e=>e.date===schedule.key);
        this.dataset.state=schedule.live?'live':'waiting';
        this.dataset.edition=String(schedule.edition);
        this.heading.textContent=edition?.title||this.config.heading;
        this.querySelector('[data-description]').textContent=schedule.live?s.liveDescription:this.config.description;
        const date=new Date(schedule.target);
        const appointment=this.querySelector('[data-appointment]');
        appointment.dateTime=date.toISOString();
        appointment.textContent=new Intl.DateTimeFormat(this.locale,{timeZone:'Europe/Rome',weekday:'long',day:'numeric',month:'long',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(date);
        this.querySelector('[data-ticket-date]').textContent=new Intl.DateTimeFormat('it-IT',{timeZone:'Europe/Rome',day:'2-digit',month:'2-digit'}).format(date).replace('/','.');
        this.querySelector('[data-ticket-year]').textContent=schedule.key.slice(0,4);
        this.querySelector('[data-ticket-caption]').textContent=schedule.live?s.live:s.saveDate;
        const link=this.querySelector('[data-cta]');
        link.setAttribute('href',schedule.live&&(edition?.url)?edition.url:this.config.url);
        link.querySelector('span').textContent=schedule.live?s.liveCta:s.browse;
        this.clock.hidden=schedule.live; this.liveLabel.hidden=!schedule.live; this.calendar.hidden=schedule.live;
        this.status.textContent=schedule.live?s.live:phase==='soon'?s.soon:phase==='today'?s.today:s.ritual;
        const teaser=this.querySelector('[data-teaser]');
        teaser.replaceChildren();
        teaser.hidden=!edition?.image;
        this.querySelector('[data-ticket-art]').hidden=!!edition?.image;
        if(edition?.image) {
          const img=document.createElement('img');
          img.src=edition.image; img.alt=s.teaserAlt; img.width=800; img.height=450;
          img.style.filter=schedule.live?'none':seconds<=86400?'blur(1px)':'blur(6px)';
          teaser.append(img);
        }
      }
      const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      for(const [key,value] of Object.entries(values)) {
        const node=this.querySelector('[data-unit="'+key+'"]');
        const text=String(value).padStart(2,'0');
        if(node.textContent!==text)node.textContent=text;
      }
    }
    saveCalendar() {
      const schedule=this.getSchedule(Date.now());
      const format=time=>new Date(time).toISOString().replace(/[-:]/g,'').replace('.000','');
      const escape=value=>String(value).replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
      const content=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//MKO STORE//Tuesday Drop//IT','CALSCALE:GREGORIAN','BEGIN:VEVENT','UID:mko-drop-'+schedule.key+'@mkostore.it','DTSTAMP:'+format(Date.now()),'DTSTART:'+format(schedule.target),'DTEND:'+format(schedule.target+3600000),'SUMMARY:'+escape(this.config.strings.calendarTitle),'URL:https://www.mkostore.it/','END:VEVENT','END:VCALENDAR'].join('\r\n')+'\r\n';
      const url=URL.createObjectURL(new Blob([content],{type:'text/calendar;charset=utf-8'}));
      const link=document.createElement('a'); link.href=url; link.download='mko-drop-'+schedule.key+'.ics';
      document.body.append(link); link.click(); link.remove();
      setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
  }
  if(!customElements.get('mko-weekly-drop'))customElements.define('mko-weekly-drop',MkoWeeklyDrop);

  } catch(e) { console.error(e); }
})();
})();
